export function getLastKey(obj) {
  if (!obj || Object.keys(obj).length === 0) {
    return null;
  }

  const maxDateKey = Object.keys(obj).reduce((max, key) => {
    const date = new Date(key);
    return date > new Date(max) ? key : max;
  }, Object.keys(obj)[0]);

  return maxDateKey;
}

export const currencyFormat = (price) => {
  if (!price || price === '--') return '--';
  // Remove all dots (thousand separators) and convert to number
  const cleanPrice =
    typeof price === 'string'
      ? price.replace(/\./g, '')
      : price.toString().replace(/\./g, '');
  const numericPrice = parseFloat(cleanPrice);

  // Return formatted currency
  return numericPrice.toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP',
  });
};

export const datetimeFormat = (datetime) => {
  if (!datetime || datetime === '--') return '--';
  return new Date(datetime).toLocaleString('es-CL', {
    hour: '2-digit',
    minute: '2-digit',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const dateFormat = (date) => {
  if (!date || date === '--') return '--';
  return new Date(date).toLocaleString('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const priceFormat = (price, iva, commission = null) => {
  return `${currencyFormat(price)} ${iva} ${
    commission ? `+ ${commission}% DE COMISIÓN` : ''
  }`;
};

export const formatFormCurrency = (value) => {
  if (value == null || value === '') return '';
  const str = typeof value === 'string' ? value : String(value);
  const number = str.replace(/\D/g, ''); // Only numbers
  if (number === '') return '';
  return new Intl.NumberFormat('es-CL').format(Number(number));
};

export const formatFormRUT = (rut) => {
  rut = rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase(); // Clean
  if (rut.length <= 1) return rut;

  const body = rut.slice(0, -1);
  const dv = rut.slice(-1);
  let formatted = '';
  let i = 0;

  for (let pos = body.length - 1; pos >= 0; pos--) {
    formatted = body[pos] + formatted;
    i++;
    if (i % 3 === 0 && pos !== 0) {
      formatted = '.' + formatted;
    }
  }

  return `${formatted}-${dv}`;
};
